module.exports = __webpack_public_path__ + "static/media/bg_middle_tab4.74a27718.png";